import React, { useState } from 'react';
import { Stack } from '@mui/material';
import { yupResolver } from '@hookform/resolvers/yup';

import ReporterList from './ReporterList';
import ReportsList from '../../dataRegions/region/ReportsList';

import { useSnackbar } from 'notistack';
import * as Yup from 'yup';
import { t } from 'i18next';
import { LoadingButton } from '@mui/lab';
import { useForm } from 'react-hook-form';
import useIsMountedRef from 'hooks/useIsMountedRef';
import { useDispatch, useSelector } from 'redux/store';
import { addReporter, getReporters, updateReporter } from 'redux/actions/reporter';
import AddReporter from './AddReporter';
import Search from '../../../../components/Search';

export default function DataReporters() {
  const { enqueueSnackbar } = useSnackbar();
  const isMounted = useIsMountedRef();
  const dispatch = useDispatch();
  const defaultValues = {
    name: '',
    email: '',
    regionIds: []
  };
  const onSubmit = async (data) => {
    try {
      const res = await dispatch(
        data?.id ? updateReporter({ id: data?.id, regions: data?.regionIds }) : addReporter(data)
      );
      if (res.error) {
        setError('afterSubmit', res.error);
        enqueueSnackbar(`${t('users.add-reporter-fail')}`, { variant: 'error' });
      } else {
        enqueueSnackbar(`${t('users.reporter-added')}`, { variant: 'success' });
        dispatch(getReporters());
        reset(defaultValues);
      }
    } catch (error) {
      if (isMounted.current) {
        setError('afterSubmit', error);
        reset(defaultValues);
        enqueueSnackbar(`${t('users.add-reporter-fail')}`, { variant: 'error' });
      }
    }
  };

  const handleEdit = (reporter) => {
    window.scrollTo({ behavior: 'smooth', top: 0 });
    const { fullName, id, regions, username } = reporter;
    const data = { name: fullName, id, regionIds: regions.map(r => r.id), email: username };
    Object.entries(data).forEach(([key, value]) => setValue(key, value));
  };

  const methods = useForm({
    defaultValues,
    resolver: yupResolver(newReporterSchema),
    mode: 'onChange'
  });
  const { reset, watch, setError, setValue } = methods;
  return (
    <Stack spacing={2}>
      <AddReporter onSubmit={onSubmit} methods={methods} />
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
        <ReporterList onEdit={handleEdit} />
      </Stack>

      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
        <ReportsList />
      </Stack>
    </Stack>
  );
}
//
// function DataReportersTitle() {
//   return (
//     <Stack>
//       <Typography variant="h4" gutterBottom>
//         Data Reporters
//       </Typography>
//     </Stack>
//   );
// }
const newReporterSchema = Yup.object().shape({
  name: Yup.string()
    .matches(/^[a-zA-Z\s]*$/, t('forms.name'))
    .required(`${t('forms.person.name')} ${t('forms.is-required')}`),
  email: Yup.string()
  .matches(/^[\w-.]+@([\w-]+.)+[\w-]{2,4}$/, 'Valid email address required.').required(t('Email is required')),
  regionIds: Yup.array().required('Region is required'),
});
